import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonDirective } from '@coreui/angular-pro';
import { TwoFactorEnforcementService } from './two-factor-enforcement.service';

/**
 * Dauerhafter Hinweis-Banner ganz oben auf jeder Seite, sobald der
 * eingeloggte User 2FA-pflichtig ist und es noch nicht aktiviert hat.
 * Nicht dismissbar — verschwindet erst, wenn 2FA aktiviert wurde.
 */
@Component({
  selector: 'app-two-factor-required-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, ButtonDirective],
  template: `
    @if (svc.mustEnable()) {
      <div
        role="alert"
        class="two-factor-banner d-flex align-items-center justify-content-between gap-3 px-3 py-2 mb-3"
        [class.is-overdue]="svc.isOverdue()"
      >
        <div class="d-flex align-items-center gap-2 flex-grow-1">
          <span aria-hidden="true" class="banner-icon">🔒</span>
          <div>
            <strong>Zwei-Faktor-Authentifizierung erforderlich.</strong>
            @if (svc.isOverdue()) {
              <span class="ms-1">
                Die Frist zur Einrichtung ist abgelaufen — bitte richte 2FA jetzt ein.
              </span>
            } @else if (svc.graceDeadlineLabel(); as deadline) {
              <span class="ms-1">
                Bitte bis <strong>{{ deadline }}</strong> einrichten
                @if (svc.daysRemaining() !== null) {
                  (noch {{ svc.daysRemaining() }} {{ svc.daysRemaining() === 1 ? 'Tag' : 'Tage' }})
                }.
              </span>
            } @else {
              <span class="ms-1">Bitte zeitnah einrichten.</span>
            }
          </div>
        </div>
        <a
          routerLink="/profil/sicherheit"
          cButton
          [color]="svc.isOverdue() ? 'danger' : 'warning'"
          size="sm"
        >
          Jetzt einrichten
        </a>
      </div>
    }
  `,
  styles: [
    `
    .two-factor-banner {
      background-color: #fff8e1;
      border: 1px solid #ffd54f;
      border-radius: 0.375rem;
      color: #5d4037;
    }
    .two-factor-banner.is-overdue {
      background-color: #ffebee;
      border-color: #ef5350;
      color: #b71c1c;
    }
    .banner-icon {
      font-size: 1.25rem;
    }
  `,
  ],
})
export class TwoFactorRequiredBannerComponent {
  protected readonly svc = inject(TwoFactorEnforcementService);
}
